package one.healthium.base.browser

import kotlinx.browser.window
import one.healthium.base.launcher.PlatformLauncher

actual class Browser {
    actual fun openUrl(platformLauncher: PlatformLauncher, url: String) {
        window.open(url, "_blank")
    }
}